export function tour(setLockTour) {
  return [
    {
      selector: ".s1-step",
      content: "This is the Settings Page, Click it! ",
      position: "right-end",
      action: (node) => {
        setLockTour(true);
        node.onclick = () => {
          setLockTour(false);
        };
      },
    },
    {
      selector: ".s2-step",
      content:
        "Here, you can give us your name and click on save changes. This name will be automatically picked up from your meetings for your task extraction. So, make sure that this name is exactly the same as the one with which you join your meetings as host/ participant. If the names are not same, you will not get expected output.",
      position: "right-end",
    },
    {
      selector: ".s3-step",
      content: "You can change your default meeting language here.",
    },
    {
      selector: ".s4-step",
      content: "You can also sync your other calendars here.",
    },
    {
      selector: ".s5-step",
      content: "You have the option to change your password in this page",
    },

    {
      selector: ".s6-step",
      content:
        "Click on Home! All your tasks and important meeting summaries are on this page.",
      position: "right-end",
      action: (node) => {
        setLockTour(true);
        node.onclick = () => {
          setLockTour(false);
        };
      },
    },
    {
      selector: ".s7-step",
      content: "Here are your tasks extracted from meetings.",
    },
    {
      selector: ".s8-step",
      content:
        "Here are all your scheduled meetings from your synced calendars shown",
    },

    {
      selector: ".s9-step",
      content:
        "Click on Meetings! This is where you will find all your meetings- upcoming or past calendar meetings or past ad hoc meetings.",
      position: "right-end",
      action: (node) => {
        setLockTour(true);
        node.onclick = () => {
          setLockTour(false);
        };
      },
    },

    {
      selector: ".s10-step",
      content:
        "Here are all your scheduled upcoming meetings from your calendar. These meetings are available here along with their scheduled times.",
    },
    {
      selector: ".s11-step",
      content:
        "If some meetings are not visible here, click on refresh calendar meetings. ",
    },

    {
      selector: ".s12-step",
      content: "Click on Past Calendar!",
      position: "top",
      action: (node) => {
        setLockTour(true);
        node.onclick = () => {
          setLockTour(false);
        };
      },
    },
    {
      selector: ".s12-p1-step",
      content:
        "Here are all your scheduled calendar meetings that have happened in the past. ",
      position: "top",
    },
    {
      selector: ".s13-step",
      content:
        "Meeting names are given here. You can edit and save the meeting names as per your convenience at any stage.",
    },

    {
      selector: ".s14-step",
      content: "Click on Details to open up a meeting summary",
      action: (node) => {
        setLockTour(true);
        node.onclick = () => {
          setLockTour(false);
        };
      },
    },
    {
      selector: ".s15-step",
      content:
        "You can see a short summary of what happened during the meeting.",
    },
    {
      selector: ".s16-step",
      content:
        "If you absolutely loved the summary, give us full 5 stars. If you did not like the summary, give us 1 star.",
    },
    {
      selector: ".s17-step",
      content: "You can look at the transcript here without downloading.",
    },
    {
      selector: ".s18-step",
      content: `If you'd like to share this summary with your colleagues, utilize the "Send Notes" feature. A popup will appear, allowing you to input multiple email addresses, separated by commas.`,
    },
    // {
    //   selector: ".s18-step",
    //   content:
    //     "Click on Send Notes! If you wish to send this summary to your colleagues, you can use Send Notes",
    //   action: (node) => {
    //     setLockTour(true);
    //     node.onclick = () => {
    //       setLockTour(false);
    //     };
    //   },
    // },
    // {
    //   selector: ".s19-step",
    //   content: "You can enter multiple email IDs, all comma separated",
    //   position: "right-end",
    // },
    // {
    //   selector: ".s19-2-step",
    //   content: "Click on Cancel",
    //   position: "right-end",
    //   action: (node) => {
    //     setLockTour(true);
    //     node.onclick = () => {
    //       setLockTour(false);
    //     };
    //   },
    // },
    {
      selector: ".s20-step",
      content:
        "You can completely delete meeting summaries using the delete button. This is an irreversible process. Meetings once deleted cannot be recovered. So, use this feature only when necessary.",
    },
    {
      selector: ".s21-step",
      content: "You can mark any meeting as important by clicking on it.",
    },
    {
      selector: ".s22-step",
      content:
        "When any meeting is marked as important, it appears here for your ease and convenience to refer back to ",
    },
    {
      selector: ".s23-step",
      content:
        "Similar to calendar meetings, all your past ad hoc meetings are saved here",
    },
    {
      selector: ".s23-extra-step",
      content:
        "To join Adhoc meetings, simply click this button, and a pop-up will appear where you can enter the meeting URL",
    },
    {
      selector: ".s24-step",
      content:
        "Click on Tasks! All the Tasks extracted from your meetings are shown on this page. Say goodbye to post meeting confusions. It is like your own mini task management tool.",
      position: "right-end",
      action: (node) => {
        setLockTour(true);
        node.onclick = () => {
          setLockTour(false);
        };
      },
    },
    {
      selector: ".s25-step",
      content: "Once the task is completed, you can mark it as complete.",
      position: "right-end",
    },
    {
      selector: ".s26-step",
      content: "You can delete it if you are not working on it.",
      position: "right-end",
    },
    {
      selector: ".s27-step",
      content:
        "This is the end of the user tour. Start using the tool and get ready for a new productive you!",
      position: "center",
    },
  ];
}
